import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../common-utils-services/axiosUtil';
import { IManageWorkGroup } from '../ManageWorkgroup.interface';
import endpoints from '@constants/configs/endpoints';
import { configs } from '@constants/configs/configs';
import { ALPHA_NUMERIC_REGEX } from '@utils/validators/regex';
import {
    IS_DEFAULT_WORKGROUP,
    MAX_WORKGROUP_NAME_LENGTH,
} from '@constants/ticketMgmt/manageWorkgroup.constants';

export default () => {
    const navigate = useNavigate();

    const redirectToTicketManagequeue = (event, workGroupName: string) => {
        event.preventDefault();
        const url = `${configs.routes.TICKET_MGMT_MANAGE_QUEUE}?queueName=${workGroupName}`;
        window.location.href = url;
    };

    const redirectToEditWorkgroupTag = (event, id: number) => {
        event.preventDefault();
        const url = `${configs.routes.TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT}/${id}`;
        navigate(url, { replace: true });
    };

    const checkIfWorkgroupNameExists = async (workgroupName: string) => {
        const url = endpoints.TICKET_MGMT_WORKGROUPS_CHECK.processReplacements({ workgroupName });
        try {
            const response = await api.get(url);
            const data = await response.data;
            if (data?.success) {
                return {
                    errorMsg: 'ticket_management.manage_workgroup.duplicateWorkGroupName',
                    isError: true,
                };
            } else {
                return { errorMsg: '', isError: false };
            }
        } catch (error) {
            console.error('Cannot check workgroup name', url);
        }
        return {
            errorMsg: '',
            isError: false,
        };
    };

    const validateWorkgroupName = (workgroupName: string) => {
        if (workgroupName.length < 1) {
            return {
                errorMsg: 'ticket_management.manage_workgroup.modal.workgroup.form.validation2.msg',
                isError: true,
            };
        } else if (!workgroupName.match(ALPHA_NUMERIC_REGEX)) {
            return {
                errorMsg: 'ticket_management.manage_workgroup.modal.workgroup.form.validation3.msg',
                isError: true,
            };
        } else if (workgroupName.length > MAX_WORKGROUP_NAME_LENGTH) {
            return {
                errorMsg: 'ticket_management.manage_workgroup.modal.workgroup.form.validation1.msg',
                isError: true,
            };
        }
        return { errorMsg: '', isError: false };
    };

    const getQueueIds = (workgroupList: IManageWorkGroup[]): string => {
        let queueIds = '';
        workgroupList.forEach(workgroup => {
            if (workgroup.defaultWorkGroup === IS_DEFAULT_WORKGROUP.YES) {
                if (queueIds === '') {
                    queueIds = workgroup.id.toString();
                } else {
                    queueIds += '|' + workgroup.id;
                }
            }
        });
        return queueIds;
    };

    const getWorkgroupNameSuggestions = async (searchWorkgroupName?: string) => {
        const url = endpoints.TICKET_MGMT_WORKGROUPS_SEARCH_WORKGROUP_NAMES.processReplacements({
            workgroupName: searchWorkgroupName,
        });

        if (!searchWorkgroupName) {
            return [];
        }

        const response = await api.get(url);
        const data = await response.data;

        if (data) {
            return data;
        } else {
            console.error('Cannot get workgroup names', url);
            return [];
        }
    };

    return {
        getWorkgroupNameSuggestions: getWorkgroupNameSuggestions,
        redirectToTicketManagequeue: useCallback(redirectToTicketManagequeue, []),
        redirectToEditWorkgroupTag: useCallback(redirectToEditWorkgroupTag, []),
        checkIfWorkgroupNameExists: useCallback(checkIfWorkgroupNameExists, []),
        validateWorkgroupName: validateWorkgroupName,
        getQueueIds: getQueueIds,
    };
};
